import { createStyles, makeStyles } from '@material-ui/core';
export var useStyles = makeStyles(function (_a) {
    var palette = _a.palette;
    return createStyles({
        root: {
            padding: 20,
            width: 328,
            boxSizing: 'border-box',
        },
        anchor: {
            width: '100%',
        },
        tagline: {
            color: palette.common.white,
            fontSize: 12,
            textTransform: 'uppercase',
            fontWeight: 'bold',
        },
        title: {
            color: palette.primary.main,
            marginTop: 6,
        },
        copy: {
            fontSize: 15,
            paddingTop: 12,
            color: palette.common.white,
        },
        link: {
            cursor: 'pointer',
        },
    });
});
//# sourceMappingURL=FloatingPopover.styles.js.map